import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Header.css';
import config from '../config'; 

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className={`header ${isOpen ? 'active' : ''}`}>
      <h1>{config.companyName}</h1>
      <div className="hamburger" onClick={toggleMenu}>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <NavLink exact to="/" className="nav-link" activeClassName="active-link" onClick={() => setIsOpen(false)}>
          Home
        </NavLink>
        <NavLink to="/contact" className="nav-link" activeClassName="active-link" onClick={() => setIsOpen(false)}>
          Contact & Support
        </NavLink>
        <Link to="https://porksmealplanner.com" className="nav-link"  activeClassName="active-link" onClick={() => setIsOpen(false)}>
        Porks Meal Planner
        </Link>
      </nav>
    </header>
  );
};

export default Header;
